module.exports = __webpack_public_path__ + "static/media/ChefVeenaArora.95523a91.png";